// End-of-Service Settlement Permissions
//
// ⚠️ RECONCILE BEFORE RELEASE — see src/permissions/payroll.js for the full note.
//
// Registered by
// database/migrations/2026_09_07_000006_add_end_of_service_permissions.php; the
// central key service allocates each id at migrate time. 1532-1537 are counted
// forward from the confirmed 1522 (HR_MANAGE_SETTINGS) in registration order —
// derived, not read.
//
//     SELECT id, name FROM permissions WHERE name LIKE 'end_of_services.%';
//
// The failure mode is closed: a wrong number hides the control rather than
// showing it to the wrong people.
export const END_OF_SERVICES_INDEX = 1532;
export const END_OF_SERVICES_CREATE = 1533;
export const END_OF_SERVICES_UPDATE = 1534;
export const END_OF_SERVICES_DELETE = 1535;
export const END_OF_SERVICES_APPROVE = 1536;
export const END_OF_SERVICES_PAY = 1537;
